export default "__VITE_ASSET__mgJKC1WA__"